import { FluidForm } from "../../shared";
import { SimpleFormProvider } from "../fluidComponents/fluidForm/SimpleFormLoader";
import React from "react";
import { CodeBlock } from "./CodeBlock";
import { ExampleAuthWrapper } from "./ExampleAuthWrapper";
const basicFormConfig = {
    "key": "example-form2",
    "label": "Example Form",
    "description": "",
    // "useGoogleDrive": false,
    "strictness": "strict",
    "fields": [
        {
            key: "Personal Information",
            label: "Personal Information",
            type: "section"
        },
        {
            "key": "name",
            "label": "Name",
            "type": "fullName"
        },
        {
            "key": "email",
            "label": "Email",
            "type": "email",
            "unique": true,
        },
        {
            "key": "birthDate",
            "label": "Birth Date",
            "type": "date"
        },
        {
            key: "Preferences",
            label: "Preferences",
            type: "section",
        },
        {
            key: "favoriteMovie",
            label: "Favorite Movie",
            type: "text"
        },
        {
            key: "favoriteBook",
            label: "Favorite Book",
            type: "text"
        },
        {
            "key": "favoriteColor",
            "label": "Colors",
            "type": "multipleOptions",
            "options": [
                {
                    "text": "red",
                    "value": "Red"
                },
                {
                    "text": "blue",
                    "value": "Blue"
                }
            ],
            "fields": []
        }
    ]
};
export function BasicForm() {
    return (React.createElement("div", { className: "space-y-5" },
        React.createElement("header", { className: "mb-2" },
            React.createElement("h1", { className: "text-xl font-semibold text-gray-900" }, "Form Styles"),
            React.createElement("p", { className: "text-gray-600 text-sm mt-1" },
                "Minimal example showing how to instantiate a ",
                React.createElement("code", { className: "px-1 py-0.5 bg-gray-100 rounded" }, "FluidForm"),
                " and render it with ",
                React.createElement("code", { className: "px-1 py-0.5 bg-gray-100 rounded" }, "SimpleFormProvider"),
                ".")),
        React.createElement("section", { className: "space-y-3" },
            React.createElement("h2", { className: "text-sm font-semibold text-gray-800" }, "Usage"),
            React.createElement(CodeBlock, { language: "html", code: `
        <FluidForm schema="{basicFormConfig}"  style="classic" /> <!-- Classic Form -->
        <FluidForm schema="{basicFormConfig}"  style="cards" /> <!-- Cards Form -->
        <FluidForm schema="{basicFormConfig}"  style="inmersive" /> <!-- Inmersive Form -->
        <FluidForm schema="{basicFormConfig}"  style="classic" layout="chat" /> <!-- Chat Only Form -->
` })),
        React.createElement("section", null,
            React.createElement(ExampleAuthWrapper, { formConfig: basicFormConfig },
                React.createElement("header", { className: "mt-10" },
                    " ",
                    React.createElement("h2", { className: "text-xl font-semibold text-gray-800" }, "Classic Form"),
                    " "),
                React.createElement("p", { className: "text-gray-600 text-sm mt-1" },
                    "This is a classic form that is rendered with the ",
                    React.createElement("code", { className: "px-1 py-0.5 bg-gray-100 rounded" }, "ClassicForm"),
                    " component."),
                " ",
                React.createElement("br", null),
                React.createElement(ClassicForm, null),
                React.createElement("header", { className: "mt-10" },
                    " ",
                    React.createElement("h2", { className: "text-xl font-semibold text-gray-800" }, "Cards Form"),
                    " "),
                React.createElement("p", { className: "text-gray-600 text-sm mt-1" },
                    "This is a cards form that is rendered with the ",
                    React.createElement("code", { className: "px-1 py-0.5 bg-gray-100 rounded" }, "CardsForm"),
                    " component."),
                " ",
                React.createElement("br", null),
                React.createElement(CardsForm, null),
                React.createElement("header", { className: "mt-10" },
                    " ",
                    React.createElement("h2", { className: "text-xl font-semibold text-gray-800" }, "Inmersive Form"),
                    " "),
                React.createElement("p", { className: "text-gray-600 text-sm mt-1" },
                    "This is a inmersive form that is rendered with the ",
                    React.createElement("code", { className: "px-1 py-0.5 bg-gray-100 rounded" }, "InmersiveForm"),
                    " component."),
                " ",
                React.createElement("br", null),
                React.createElement(InmersiveForm, null),
                React.createElement("header", { className: "mt-10" },
                    " ",
                    React.createElement("h2", { className: "text-xl font-semibold text-gray-800" }, "Chat Only Form"),
                    " "),
                React.createElement("p", { className: "text-gray-600 text-sm mt-1" },
                    "This is a chat only form that is rendered with the ",
                    React.createElement("code", { className: "px-1 py-0.5 bg-gray-100 rounded" }, "ChatOnlyForm"),
                    " component."),
                " ",
                React.createElement("br", null),
                React.createElement(ChatOnlyForm, null)))));
}
export function ClassicForm() {
    let form = new FluidForm(basicFormConfig, {
        "name": "Ricardo",
        "email": "ricardodpsx@gmail.",
        "birthDate": "1990-08-23",
        "favoriteColor": ""
    }, {
        styleConfig: {
            style: "classic",
            inputModes: ["speech", "camera", "fileUpload", "urlCapture"]
        }
    });
    return (React.createElement("div", null,
        React.createElement(SimpleFormProvider, { form: form, submissionId: "example-submission" })));
}
export function CardsForm() {
    let form = new FluidForm(basicFormConfig, {
        "name": "Ricardo",
        "email": "ricardodpsx@gmail.",
        "birthDate": "1990-08-23",
        "favoriteColor": ""
    }, {
        styleConfig: {
            style: "cards",
            inputModes: ["speech", "camera", "fileUpload", "urlCapture"]
        }
    });
    return (React.createElement("div", null,
        React.createElement(SimpleFormProvider, { form: form, submissionId: "example-submission" })));
}
export function InmersiveForm() {
    let form = new FluidForm(basicFormConfig, {
        "name": "Ricardo",
        "email": "ricardodpsx@gmail.",
        "birthDate": "1990-08-23",
        "favoriteColor": ""
    }, {
        styleConfig: {
            style: "inmersive",
            inputModes: ["speech", "camera", "fileUpload", "urlCapture"]
        }
    });
    return (React.createElement("div", null,
        React.createElement(SimpleFormProvider, { form: form, submissionId: "example-submission" })));
}
export function ChatOnlyForm() {
    let form = new FluidForm(basicFormConfig, {
        "name": "Ricardo",
        "email": "ricardodpsx@gmail.",
        "birthDate": "1990-08-23",
        "favoriteColor": ""
    }, {
        styleConfig: {
            style: "classic",
            layout: "chat",
            inputModes: ["speech", "camera", "fileUpload", "urlCapture"]
        }
    });
    return (React.createElement("div", null,
        React.createElement(SimpleFormProvider, { form: form, submissionId: "example-submission" })));
}
